/**
 * Why an access-settings dialog (public access level, stored access policies) cannot save yet — F12, ruling P3: an
 * unavailable Save says why instead of a bare native `disabled`. A pending write stays a transient native disabled.
 */
export const ACL_SETTINGS_LOADING = 'The access settings are still loading.';
export const ACL_SETTINGS_READ_FAILED = 'The access settings could not be read; use Retry first.';
export const ACL_RELOAD_FIRST = 'Reload the access settings first.';

export function aclSaveReason(state: { loaded: boolean; readFailed: boolean; stale?: string }): string | undefined {
  if (!state.loaded) return state.readFailed ? ACL_SETTINGS_READ_FAILED : ACL_SETTINGS_LOADING;
  return state.stale ? ACL_RELOAD_FIRST : undefined;
}
